import { useQuery } from '@tanstack/react-query'
import { graphqlClient } from '@/lib/graphql_client'
import { TeamMembersDocument } from '@/gql/graphql'
import { Card, CardContent, CardHeader } from '@/components/ui/Card'
import { SectionEyebrow } from '@/components/ui/SectionEyebrow'
import { Monogram } from '@/components/ui/Monogram'
import { Text } from '@/components/ui/Text'

export function Day0PeopleCard() {
  const { data, isPending, isError } = useQuery({
    queryKey: ['teamMembers'],
    queryFn: () => graphqlClient.request(TeamMembersDocument),
  })

  // B5: 403/error degrades to empty array — never an error UI
  const members =
    isPending
      ? null
      : isError || !data
        ? []
        : data.teamMembers.map((m) => ({
            id: m.platformUserId,
            displayName: m.displayName ?? m.email ?? '—',
            role: m.role?.name ?? '—',
          }))

  return (
    <Card data-testid="day0-people-card">
      <CardHeader className="flex-row items-center py-4">
        <SectionEyebrow>PEOPLE</SectionEyebrow>
      </CardHeader>
      <CardContent>
        {members === null ? null : members.length === 0 ? (
          <Text variant="body-sm" color="muted">
            No team members assigned yet.
          </Text>
        ) : (
          <ul className="flex flex-col gap-3">
            {members.map((m) => (
              <li key={m.id} className="flex items-center gap-3">
                <Monogram name={m.displayName} size="sm" />
                <div className="flex flex-col min-w-0">
                  <Text variant="label-sm">{m.displayName}</Text>
                  <Text variant="body-sm" color="muted">
                    {m.role}
                  </Text>
                </div>
              </li>
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  )
}
